import { render, staticRenderFns } from "./index.vue?vue&type=template&id=3b8af378&scoped=true"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b8af378",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/work/jenkins/workspace/pre预发布-anjun-express-web-management/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3b8af378')) {
      api.createRecord('3b8af378', component.options)
    } else {
      api.reload('3b8af378', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=3b8af378&scoped=true", function () {
      api.rerender('3b8af378', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/ReportManagement/customerQualityDashboard/index.vue"
export default component.exports